import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { getSelectedSede, switchSede } from '../../utils/sede';

/**
 * Sede activa en la barra superior. El ADMIN con varias sedes elige una o el consolidado;
 * los demás solo ven en qué sede están trabajando.
 */
export default function SedeSelector() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const sedes = user?.sedes ?? [];
  if (!user || user.rol === 'SUPERADMIN' || sedes.length === 0) return null;

  const selectedId = getSelectedSede();
  const selected = sedes.find((s) => s.id === selectedId);
  const canSwitch = user.rol === 'ADMIN' && sedes.length > 1;

  if (!canSwitch) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 bg-slate-100 rounded-xl text-sm text-slate-700 max-w-[200px]">
        <i className="ri-map-pin-2-line text-teal-600"></i>
        <span className="truncate font-medium">{selected?.nombre ?? sedes[0].nombre}</span>
      </div>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-2 px-3 py-1.5 rounded-xl text-sm border transition max-w-[220px] ${
          selected ? 'bg-teal-50 border-teal-200 text-teal-700' : 'bg-amber-50 border-amber-200 text-amber-700'
        }`}
        title="Cambiar de sede"
      >
        <i className="ri-map-pin-2-line"></i>
        <span className="truncate font-medium">{selected?.nombre ?? 'Todas las sedes'}</span>
        <i className="ri-arrow-down-s-line"></i>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute left-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-slate-200 py-2 z-50">
            <p className="px-4 pb-2 text-xs text-slate-500 border-b border-slate-100">
              Las operaciones (entradas, turnos, ventas) se registran en la sede seleccionada.
            </p>
            <button
              onClick={() => switchSede(null)}
              className={`w-full px-4 py-2 text-left text-sm flex items-center gap-2 hover:bg-slate-50 ${!selected ? 'text-teal-600 font-medium' : 'text-slate-700'}`}
            >
              <i className="ri-stack-line"></i>
              Todas las sedes (consolidado)
            </button>
            {sedes.map((sede) => (
              <button
                key={sede.id}
                onClick={() => switchSede(sede.id)}
                className={`w-full px-4 py-2 text-left text-sm flex items-center gap-2 hover:bg-slate-50 ${selected?.id === sede.id ? 'text-teal-600 font-medium' : 'text-slate-700'}`}
              >
                <i className="ri-map-pin-line"></i>
                <span className="truncate">{sede.nombre}</span>
                {selected?.id === sede.id && <i className="ri-check-line ml-auto"></i>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
